<template>
<layout-content>
  <template #toolbar>
    <period-time
      :query="query"
      :start-date-picker-options="startDatePickerOptions"
      :end-date-picker-options="endDatePickerOptions"
      :show-options="showOptions"
    >
      <site-query :sites="filterSites" :query="query" />

      <el-radio-group v-model="isShowFactor" size="small" @change="onIsShowFactorChanged">
        <el-radio-button :label="true">物种</el-radio-button>
        <el-radio-button :label="false">组分</el-radio-button>
      </el-radio-group>

      <factor-tree-query
        v-if="isShowFactor"
        ref="factor-tree"
        :factor-tree="factorTree"
        :query="query"
      />

      <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border /> -->

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="onSearchBtnClick"
      >查询</el-button>
    </period-time>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <div style="flex:1;padding:0 12px;"></div>

        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <div style="position:relative;flex:1;display:flex;justify-content:flex-end;padding:0 12px;">
          <PassLegend />
        </div>
      </template>

      <report-data-table
        v-for="data in dataList"
        :granularity="query.granularity"
        :key="data.id"
        :current-query="currentQuery"
        :data-config="data"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
// import DataFormatter from '../../../../model/DataFormatter'
import unitConverter from '../../../../utils/unitConverter'

import LayoutContent from '../../../../components/Layout/Content'
import PeriodTime from '../../../../components/Data/PeriodTime'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import FactorTreeQuery from '../../../../components/Data/Query/FactorTreeQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import ReportDataTable from '../../02Normal/ReportDataTable'

export default {
  name: 'DataManagementVOCsPeriodTimeReport',
  routeInfo: {
    label: 'VOCs均值统计',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, PeriodTime, SiteQuery, FactorTreeQuery, DataWrapper, CompletedQuery, UnitSwitch, ReportDataTable},
  data: () => ({
    query: {
      granularity: 'day_and_night',
      isMultipleIntegral: true
    },
    isShowFactor: true
  }),
  computed: {
    showOptions () {
      return ['day_and_night', 'hour', 'day', 'month', 'quarter', 'year']
    },
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, true)
    ],
    isSetAllFactorIds () {
      return !this.isShowFactor
    },
    isSetUnit: () => true,
    filterSites () {
      if (this.isShowFactor) {
        return this._filterSites
      } else {
        let {factorGroupMap} = this

        return this._filterSites.map(site => ({
          ...site,
          devices: site.devices.map(device => {
            let {siteDeviceFactors} = device
            let vocsObj = {
              id: 'total',
              factorId: 'total',
              name: 'VOCs总量',
              parentId: null,
              status: true
            }

            Object.defineProperty(vocsObj, 'stdUnit', {
              get: this.getUnit(siteDeviceFactors[0]),
              enumerable: true
            })

            Object.defineProperty(vocsObj, 'displayUnit', {
              get: this.getUnit(siteDeviceFactors[0]),
              enumerable: true
            })

            return {
              ...device,
              siteDeviceFactors: Object.values(siteDeviceFactors.reduce((map, siteDeviceFactor) => {
                let {parentId} = siteDeviceFactor

                if (!map[parentId]) {
                  let factorGroup = factorGroupMap[parentId]

                  if (factorGroup) {
                    let newFactor = {
                      id: parentId,
                      factorId: parentId,
                      name: factorGroup.name,
                      parentId: factorGroup.parentId,
                      status: true
                    }

                    Object.defineProperty(newFactor, 'stdUnit', {
                      get: this.getUnit(siteDeviceFactor),
                      enumerable: true
                    })

                    Object.defineProperty(newFactor, 'displayUnit', {
                      get: this.getUnit(siteDeviceFactor),
                      enumerable: true
                    })

                    map[parentId] = newFactor
                  }
                }

                return map
              }, {
                [vocsObj.id]: vocsObj
              }))
            }
          })
        }))
      }
    },
    factorTree () {
      let {_factorTree} = this

      if (_factorTree.length === 1) {
        let {children} = _factorTree[0]

        if (Array.isArray(children) && children.length !== 0) {
          _factorTree = children
        }
      }

      return JSON.parse(JSON.stringify(_factorTree))
    },
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    }
  },
  methods: {
    getUnit (factor) {
      return () => factor[this.unitProp]
    },
    afterSetSiteIds () {
      setTimeout(() => {
        if (this.setOther()) {
          this.setCurrentQuery()
          this.getData()
        }
      }, 0)
    },
    changeQueryTime (query) {
      let data = JSON.parse(JSON.stringify(query))
      delete data.dataType
      delete data.isAuditCompleted
      delete data.isGetInvalidData
      if (this.isShowFactor) {
        delete data.unit
      } else {
        data.groupIds = query.factorIds.filter(el => el !== 'm30000')
        delete data.factorIds
      }
      let {granularity, beginTime, endTime} = query
      switch (granularity) {
        case 'year':
          data.beginTime = new Date(beginTime).format('YYYY/01/01 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/12/31 23:59:59')
          break
        case 'month':
          let date = new Date(endTime)
          let year = date.getFullYear()
          let month = date.getMonth() + 1
          data.beginTime = new Date(beginTime).format('YYYY/MM/01 00:00:00')
          data.endTime = new Date(year, month, 0).format('YYYY/MM/DD 23:59:59')
          break
        case 'day':
          data.beginTime = new Date(beginTime).format('YYYY/MM/DD 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/MM/DD 23:59:59')
          break
        case 'hour':
          data.beginTime = new Date(beginTime).format('YYYY/MM/DD 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/MM/DD 23:59:59')
          break
      }

      return data
    },
    getData () {
      this.changeLoadStatus(true)
      let query = this.changeQueryTime(this.query)

      this.$api.AvgData[this.isShowFactor ? 'getOtherAvgData' : 'getVocsGroupAvgData'](query).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      this.tmpList = Object.freeze(dataList)
      this.formatData()
      this.newFormatData()
    },
    // formatData: DataFormatter.format4,
    formatData () {
      let {currentQuery, tmpList} = this

      if (Object.keys(currentQuery).length === 0) {
        return
      }

      let {dimension} = this
      let otherDimension = dimension ^ 1

      let dimensionIdProps = new Array(2)
      dimensionIdProps[dimension] = 'siteId'
      dimensionIdProps[otherDimension] = 'factorId'
      let [dimensionIdProp0] = dimensionIdProps

      let dimensionIds = new Array(2)
      dimensionIds[dimension] = currentQuery.siteIds
      dimensionIds[otherDimension] = currentQuery.factorIds
      let [dimensionIds0, dimensionIds1] = dimensionIds

      let {siteFactorMap, factorSiteMap, unitProp} = this
      let dimensionObjects = new Array(2)
      dimensionObjects[dimension] = siteFactorMap
      dimensionObjects[otherDimension] = factorSiteMap
      let dimensionObjectMap = dimensionObjects[0]

      this.dataList = Object.freeze(Object.values(tmpList.reduce((map, data) => {
        let newDataConfig = map[data[dimensionIdProp0]]

        if (newDataConfig) {
          newDataConfig.dataList = data.data.map(data => newDataConfig.dimensions.reduce((newData, dimension) => {
            let dimensionId = dimension.id
            let value = data[dimensionId] ? data[dimensionId].value : '--'
            newData[dimensionId] = Number.isFinite(value) ? Number(unitConverter(value, dimension.stdUnit, dimension[unitProp], dimension.molecular).toFixed(3)) : '--'
            newData[dimensionId + 'Flag'] = data[dimensionId] ? data[dimensionId].isHaveIntegral : false
            newData[dimensionId + 'isPass'] = data[dimensionId] ? Number(data[dimensionId].isPass) : undefined
            return newData
          }, {
            dataTime: data.dataTime
          }))
        }

        return map
      }, dimensionIds0.reduce((map, dimensionId) => {
        let dimensionObject = dimensionObjectMap[dimensionId]
        let subDimensionMap = dimensionObject.map
        let seriesDimensions = dimensionIds1.reduce((list, id) => {
          let dimensionObj = subDimensionMap[id]

          if (dimensionObj) {
            list.push(dimensionObj)
          }

          return list
        }, [])

        map[dimensionId] = {
          id: dimensionId,
          name: dimensionObject.name,
          dimensions: seriesDimensions,
          unitProp,
          dataList: []
        }

        return map
      }, {}))))
    },
    newFormatData () {
      let dataList = JSON.parse(JSON.stringify(this.dataList))
      this.dataList = dataList.map(el => {
        el.dataList.forEach(data => {
          let total = 0
          let flag = false
          for (let key in data) {
            if (key !== 'dataTime' && data[key] !== '--' && typeof data[key] !== 'boolean') {
              total += data[key]
            }

            if (typeof data[key] === 'boolean' && data[key]) {
              flag = true
            }
          }
          data.total = total ? total.toFixed(2) : '--'
          data.totalFlag = flag
        })

        return {...el}
      })
      console.log(dataList)
    },
    onIsShowFactorChanged (isShowFactor) {
      let {query} = this

      if (isShowFactor) {
        query.factorIds = this.factorIds

        setTimeout(() => {
          let factorTreeComponent = this.getFactorTree()

          if (factorTreeComponent) {
            factorTreeComponent.setCheckedKeys(query.factorIds)
          }
        }, 0)
      } else {
        let {filterFactors} = this
        this.factorIds = query.factorIds

        if (filterFactors.length > 0) {
          query.factorIds = filterFactors.map(factor => factor.id)
          query.unit = filterFactors[0][this.unitProp]
        } else {
          query.factorIds = []
        }
      }
    },
    onUnitPropChange () {
      if (this.isShowFactor) {
        this.formatData()
      } else {
        let {filterFactors} = this

        if (filterFactors.length > 0) {
          this.query.unit = filterFactors[0][this.unitProp]
          this.onSearchBtnClick()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/01Data-Statistical/02VOCs-Period-time/index.vue